<template>
  <b-row>
    <b-col cols="12" class="mb-1">
      <router-link
        v-if="item"
        :to="{ name: 'EXCMCaseTypeList' }"
        class="btn btn-sm btn-default float-right">{{$t('buttons.backToList')}}</router-link>
    </b-col>
    <b-col cols="12">
      <b-row v-if="isLoading">
        <b-col>
          <Loader size="lg"></Loader>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <b-card>
            <b-tabs>
              <b-tab :title="$t('views.excmcase.update.title')">
                <EXCMCaseTypeForm
                  v-if="item"
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations"
                  :initial-values="retrieved" />
              </b-tab>
              <b-tab :title="$t('views.excmcasetype.create.titleRoles')">
                <CreateRolesForCaseType
                  @roleWithPermissions="retrieved.allowedAccessRole = $event"
                  :initialRoleWithPermissions="retrieved.allowedAccessRole"
                ></CreateRolesForCaseType>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMCaseTypeForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import CreateRolesForCaseType from '@/components/Dashboard/Views/excmcasetype/CreateRolesForCaseType'

export default {
  components: {
    CreateRolesForCaseType,
    EXCMCaseTypeForm,
    Loader
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmcasetype/update/isLoading',
      error: 'excmcasetype/update/error',
      deleteError: 'excmcasetype/del/error',
      deleteLoading: 'excmcasetype/del/isLoading',
      created: 'excmcasetype/create/created',
      deleted: 'excmcasetype/del/deleted',
      retrieved: 'excmcasetype/update/retrieved',
      updated: 'excmcasetype/update/updated',
      violations: 'excmcasetype/update/violations',
      customFieldUpdated: 'excmcustomfield/update/updated',
      customFieldCreated: 'excmcustomfield/create/created'
    })
  },

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMCaseTypeUpdate')
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMCaseTypeList' })
    },

    retrieved: function (retrieved) {
      if (this.retrieved.defaultTask && this.retrieved.defaultTask['@id']) {
        this.retrieved.defaultTask = this.retrieved.defaultTask['@id']
      }
    },
    updated: function (updated) {
      if (this.routeName === 'EXCMCaseTypeShow') {
        this.$emit('input', 1)
      }
    },
    customFieldUpdated: function (updated) {
      if (!updated) {
        return
      }
      this.retrieve(decodeURIComponent(this.$route.params.id))
      this.$store.state.excmcustomfield.update.updated = null
    },
    customFieldCreated: function (created) {
      if (!created) {
        return
      }
      this.retrieve(decodeURIComponent(this.$route.params.id))
      this.$store.state.excmcustomfield.create.created = null
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmcasetype/create/reset',
      deleteItem: 'excmcasetype/del/del',
      delReset: 'excmcasetype/del/reset',
      retrieve: 'excmcasetype/update/retrieve',
      updateReset: 'excmcasetype/update/reset',
      update: 'excmcasetype/update/update',
      updateRetrieved: 'excmcasetype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmcasetype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
